import React, { useEffect } from 'react'
import { Button, Col, Form, Input, message, Modal, Row } from 'antd'
import { inject, observer } from 'mobx-react'
import validator from '../../validator'

const PopupLoginAccount = props => {
  const {
    selectedAccount,
    isVisible,
    onClose,
    onLoginSuccess,
    loadingAnimationStore,
    sameDocumentStore,
  } = props

  const [form] = Form.useForm()

  const onFinish = async values => {
    try {
      loadingAnimationStore.showSpinner(true)
      await sameDocumentStore.login(values)

      onClose()
      onLoginSuccess()
      loadingAnimationStore.showSpinner(false)
    } catch (e) {
      message.error('Tài khoản không đúng')
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      username: '',
      password: '',
    })
  }, [selectedAccount, isVisible])

  const closeAndResetForm = () => {
    onClose()
  }

  return (
    <>
      <Modal
        title="Tài khoản"
        footer={null}
        closable={false}
        onCancel={() => {
          closeAndResetForm()
        }}
        visible={isVisible}>
        <Form
          form={form}
          scrollToFirstError
          name={'account-edit-form'}
          onFinish={onFinish}
          layout={'vertical'}>
          <Form.Item
            label={'Tên đăng nhập'}
            name={'username'}
            rules={[
              { required: true, message: 'Vui lòng nhập tên đăng nhập' },
              { validator: validator.validateInputString },
            ]}>
            <Input
              autoComplete={'Tên đăng nhập'}
              placeholder={'Tên đăng nhập'}
            />
          </Form.Item>
          <Form.Item
            label={'Mật khẩu'}
            name={'password'}
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]}>
            <Input.Password
              autoComplete={'new-password'}
              placeholder={'Mật khẩu'}
            />
          </Form.Item>

          <Row
            type={'flex'}
            style={{ marginTop: 30 }}
            justify={'space-between'}
            gutter={15}>
            <Col span={12}>
              <Button block type={'default'} onClick={onClose}>
                Đóng
              </Button>
            </Col>
            <Col span={12}>
              <Button block type={'primary'} htmlType="submit">
                Đăng nhập
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

PopupLoginAccount.propTypes = {}

export default inject(
  'userStore',
  'authenticationStore',
  'loadingAnimationStore',
  'commandStore',
  'accountEditStore',
  'sameDocumentStore'
)(observer(PopupLoginAccount))
